export const REFERRER_QUERY_PARAM = 'referrer'
export const LOGIN_ROUTE = 'index'
export const LOGOUT_ROUTE = 'logout'

export function redirectToLogoutPage () {
  location.assign('/logout')
}

export function createRoute (name, options = {}) {
  if (name != null) {
    return {
      name,
      params: options.params,
      query: options.query
    }
  }
}

export function createLoginRoute (options = {}) {
  return createRoute(LOGIN_ROUTE, options)
}

export function createLogoutRoute (options = {}) {
  return createRoute(LOGOUT_ROUTE, options)
}
